import { ThemeConfig } from './theme-config';

export const DEFAULT_THEME: ThemeConfig = {
  themeId: 'pathfind',
  mainColors: {
    primary: '#23a086',
    accent: '#186e5d',
    warn: '#d32f2f',
  },
};

export const createTheme = (color: string, accent: string): ThemeConfig => ({
  themeId: color,
  mainColors: {primary: color, accent, warn: '#d32f2f'},
});
